import React, { PureComponent } from "react";

import Filter from "Common/Filter";
import MediaList from "Common/MediaList";

import styles from "./Archive.local.scss";
import Button from "Common/Button/Button";
import _ from "i18n";

export default class ArchiveComponent extends PureComponent {
  state = {
    status: ["ARCHIVED"]
  };

  handleChangeStatus = status => {
    const { fetchMedias, resetFilter } = this.props;
    resetFilter();
    this.setState({ status: [status] });
    fetchMedias({ filterBy: { status: [status] }, limit: 42 });
  };

  render() {
    const { community, medias, filter, fetchMedias } = this.props;
    let tabs = [];
    if (community) {
      const { mediaSettings } = community;
      tabs =
        mediaSettings &&
        mediaSettings.preferences &&
        mediaSettings.preferences.generalTypes
          ? mediaSettings.preferences.generalTypes.split(",")
          : [];
    }

    return (
      <div className={styles.myMedias}>
        <div className={styles.header}>
          <div class={styles.tabs}>
            <Button
              onClick={() => this.handleChangeStatus("ARCHIVED")}
              variant={
                this.state.status.includes("ARCHIVED") ? "primary" : "default"
              }
            >
              {_("archived")}
            </Button>
            <Button
              onClick={() => this.handleChangeStatus("MASKED")}
              variant={
                this.state.status.includes("MASKED") ? "primary" : "default"
              }
            >
              {_("masked")}
            </Button>
          </div>
        </div>
        <div className={styles.body}>
          <div className={styles.filter}>
            <Filter
              tabs={tabs}
              filter={filter}
              fetchMedias={fetchMedias}
              withSearch={true}
              status={this.state.status}
            />
          </div>
          <div className={styles.medias}>
            <MediaList medias={medias.items} fetching={medias.fetching} />
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Archive/ArchiveComponent.js